
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useCheckoutStore } from '@/stores/checkoutStore';

const CompanyInfoSection = () => {
  const { needsInvoice, company, setField } = useCheckoutStore();
  
  // If user doesn't need an invoice, don't render this section
  if (!needsInvoice) return null;
  
  // Initialize company if not yet set
  const companyData = company || { name: '', registrationCode: '', vatNumber: '' };
  
  const updateCompany = (field: keyof typeof companyData, value: string) => {
    const updatedCompany = { ...companyData, [field]: value };
    setField('company', updatedCompany);
  };
  
  return (
    <Card id="company-info" className="scroll-mt-24">
      <CardHeader className="pb-3">
        <CardTitle className="text-gray-700">2. Arve andmed</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="company-name" className="text-gray-600">
            Ettevõtte nimi*
          </Label>
          <Input
            id="company-name"
            type="text"
            value={companyData.name}
            onChange={(e) => updateCompany('name', e.target.value)}
            required
            className="w-full"
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="company-reg" className="text-gray-600">
            Registrikood*
          </Label>
          <Input
            id="company-reg"
            type="text"
            value={companyData.registrationCode}
            onChange={(e) => updateCompany('registrationCode', e.target.value)}
            required
            className="w-full"
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="company-vat" className="text-gray-600">
            KMKR
          </Label>
          <Input
            id="company-vat"
            type="text"
            value={companyData.vatNumber || ''}
            onChange={(e) => updateCompany('vatNumber', e.target.value)}
            className="w-full"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default CompanyInfoSection;
